import { useEffect, useState } from 'react';
import { getPublicPage } from '../api/contentApi';
import { resolveWealthDetailContent } from '../utils/wealthDetailFallback';

export const useWealthDetailContent = (slug, product) => {
  const [content, setContent] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const load = async () => {
      setIsLoading(true);

      try {
        const page = await getPublicPage(slug);
        if (!isMounted) {
          return;
        }

        setContent(resolveWealthDetailContent(page, product));
        setError(null);
      } catch (err) {
        if (!isMounted) {
          return;
        }

        setContent(product ? resolveWealthDetailContent(null, product) : null);
        setError(err);
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    if (slug && product) {
      load();
    } else {
      setContent(null);
      setIsLoading(false);
    }

    return () => {
      isMounted = false;
    };
  }, [slug, product]);

  return { content, isLoading, error };
};
